import { fmtDate } from "@/lib/utils";
import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MapPin, ArrowRight, Calendar, Truck, Route, HelpCircle } from "lucide-react";

export default function SeoRoute() {
  const { seoSlug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!seoSlug || !seoSlug.startsWith("beiladung-")) { setNotFound(true); return; }
    api.get(`/seo/pages/${seoSlug}`).then(({ data }) => setPage(data)).catch(() => setNotFound(true));
  }, [seoSlug]);

  if (notFound) return <div className="eb-container py-24 text-center"><h1 className="font-head text-2xl font-bold">Seite nicht gefunden</h1><Link to="/aktuelle-beiladungen" className="eb-btn-outline mt-6">Aktuelle Beiladungen</Link></div>;
  if (!page) return <div className="eb-container py-16 text-slate-400">Lädt…</div>;

  return (
    <div>
      <section className="relative overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0"><img src="https://images.pexels.com/photos/10802569/pexels-photo-10802569.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="" className="w-full h-full object-cover opacity-20" /><div className="absolute inset-0 bg-gradient-to-b from-[#0B0F17]/80 to-[#0B0F17]" /></div>
        <div className="relative eb-container py-16">
          <span className="eb-badge bg-[#FF5A1F]/15 text-[#FF8A5F] mb-4"><Route className="w-3.5 h-3.5" /> Beiladung Route</span>
          <h1 className="font-head text-4xl lg:text-5xl font-extrabold" data-testid="seo-h1">{page.h1}</h1>
          <p className="text-lg text-slate-300 mt-4 max-w-2xl">{page.description}</p>
          <div className="flex flex-wrap gap-4 mt-6 text-sm text-slate-400">
            {page.distance_km && <span className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#FF5A1F]" /> ca. {page.distance_km} km</span>}
            {page.typical_time && <span className="flex items-center gap-2"><Calendar className="w-4 h-4 text-[#FF5A1F]" /> Fahrzeit {page.typical_time}</span>}
          </div>
          <Link to="/anfrage" className="eb-btn-primary mt-8" data-testid="seo-cta">Anfrage für diese Strecke <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>

      <section className="eb-container eb-section">
        <h2 className="font-head text-2xl font-bold mb-6">Aktuelle Beiladungen auf dieser Strecke</h2>
        {page.active_trips?.length === 0 ? (
          <div className="eb-card p-8 text-center" data-testid="seo-no-trips">
            <p className="text-slate-300 mb-4">Aktuell ist für diese Strecke keine passende Beiladung verfügbar.</p>
            <Link to="/anfrage" className="eb-btn-primary">Anfrage stellen</Link>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {page.active_trips.map((t) => (
              <div key={t.id} className="eb-card eb-card-hover p-6">
                <span className="eb-badge bg-emerald-500/15 text-emerald-400 mono mb-3">{t.freie_m3} m³ frei</span>
                <div className="flex items-center gap-2 font-head font-semibold"><MapPin className="w-4 h-4 text-[#FF5A1F]" /> {t.start_ort} <ArrowRight className="w-4 h-4 text-slate-600" /> {t.ziel_ort}</div>
                <div className="text-sm text-slate-400 mt-2 flex items-center gap-2"><Calendar className="w-4 h-4" /> {fmtDate(t.abfahrt)} · <Truck className="w-4 h-4" /> {t.vehicle_type}</div>
                <Link to="/anfrage" className="eb-btn-outline w-full mt-4 !py-2 text-sm">Anfragen</Link>
              </div>
            ))}
          </div>
        )}
      </section>

      {page.faq?.length > 0 && (
        <section className="eb-container eb-section border-t border-slate-800">
          <h2 className="font-head text-2xl font-bold mb-6">Häufige Fragen</h2>
          <div className="space-y-3 max-w-3xl">
            {page.faq.map((q, i) => (
              <div key={i} className="eb-card p-5"><div className="flex items-start gap-2 font-semibold text-slate-100"><HelpCircle className="w-4 h-4 text-[#FF5A1F] mt-0.5" /> {q.q}</div><p className="text-sm text-slate-400 mt-2 pl-6">{q.a}</p></div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
